module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjYzEwMDAwIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMjE4LjMwOHYxNzQuOTZIMHoiLz4KICAgIDxnIGZpbGw9IiNjMTAwMDAiPgogICAgICA8cGF0aCBkPSJNODkuODMyIDI3LjI4NWgzNC43OTV2MTIxLjg3M0g4OS44MzJ6Ii8+CiAgICAgIDxwYXRoIGQ9Ik0xNjguMTcxIDcwLjgydjM0Ljc5NUg0Ni4yOThWNzAuODJ6Ii8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/to.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/to.svg
// module chunks = 0